<template>
  <b-modal id="preview" @hide="previewModalClose" ref="previewModal" :title="$t('プレビュー')" hide-footer :hide-header="isHideHeader">
    <template v-if="businessForms.length">
      <template v-for="(data, index) in businessForms">
        <SvgEditPrinter
          :key="index"
          :index="index"
          ref="svgEditPrinter"
          @loaded="showSvgEditPrinter"
        />
      </template>
    </template>
  </b-modal>
</template>

<script>
import Api from '../../mixin/api'
import { mapGetters } from 'vuex'
import SvgEditPrinter from '@/components/svgEditPrinter'

export default {
  components: { SvgEditPrinter },
  mixins: [
    Api,
  ],
  props: {
    company: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      isHideHeader: false,
      templateFileId: null,
      businessForms: [],
    }
  },
  methods: {
    previewModalOpen(business_form = {}) {
      this.templateFileId = business_form.templateFileId
      this.businessForms.push(business_form)
      this.$refs.previewModal.show()
    },
    previewModalClose() {
      this.templateFileId = null
      this.businessForms = []
      this.$refs.previewModal.hide()
    },
    async getTemplateFile(params) {
      let res = null
      try {
        res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/template_file`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params,
          }
        )
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
      return res
    },
    async showSvgEditPrinter(index) {
      const editor = this.$refs.svgEditPrinter[index]

      const params = { id: this.templateFileId }
      const { data } = await this.getTemplateFile(params)
      if (!data) return

      const template = data.data

      const logoImageId = '会社ロゴ'
      const signImageId = '印影'
      const logoValue = await editor.getImageValue(this.company.logoImageURL, logoImageId)
      const signValue = await editor.getImageValue(this.company.signImageURL, signImageId)
      const images = [{id: logoImageId, value: logoValue}, {id: signImageId, value: signValue}]

      const values = [
        { id: '発行日', value: '2022/01/01' },
        { id: '見積No.', value: '20220101-0001' },
        { id: '納品No.', value: '20220101-0001' },
        { id: '発注No.', value: '20220101-0001' },
        { id: '請求No.', value: '20220101-0001' },
        { id: '依頼No.', value: '20220101-0001' },
        { id: '会社名', value: this.company.name },
        { id: '郵便番号', value: this.company.zipcode },
        { id: '都道府県', value: this.company.prefName },
        { id: '住所1', value: this.company.address1 },
        { id: '住所2', value: this.company.address2 },
        { id: '住所3', value: this.company.address3 },
        { id: 'TEL', value: this.company.phoneNo },
        { id: 'FAX', value: this.company.faxNo },
        { id: 'Email', value: this.company.email },
        { id: '振込先1', value: this.company.payee1 },
        { id: '振込先2', value: this.company.payee2 },
        { id: '振込先3', value: this.company.payee3 },
        { id: '振込先4', value: this.company.payee4 },
        { id: '振込先5', value: this.company.payee5 },
        { id: '取引先名', value: '取引先サンプル' },
        { id: '件名', value: '帳票サンプル' },
        { id: '見積有効期限', value: '2021/12/31' },
        { id: '担当者', value: 'サンプル担当者' },
        { id: '小計', value: 100000 },
        { id: '消費税', value: 10000 },
        { id: '合計', value: 110000 },
        { id: '取引方法', value: '現金' },
        { id: '備考', value: 'サンプルです' },
        { id: '希望納期', value: '2021/01/31' },
        { id: '納品日', value: '2021/01/30' },
        { id: '支払期限', value: '2021/02/28' },
        { id: '納入期日', value: '2021/01/31  ' },
      ]

      const rows = [{
        'orderno': '20220101-0001',
        'estimateno': '20220101-0001',
        'dispatchno': '20220101-0001',
        'delivery_date': '2022-01-31',
        'productcode': 'サンプル品番',
        'productname': 'サンプル品名',
        'figureno': 'サンプル図番',
        'quantity': 50,
        'unit': 'kg',
        'note': 'サンプルです',
        'unitprice': 2000,
        'price': 100000,
      }]

      editor.showSvgData(template, values, rows, images)
    },
  },
  watch: {
    //
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .q-btn__content.col, .row {
    margin: 0 !important;
  }
  #preview {
    display: flex !important;
    justify-content: center;
    padding: 0 !important;
    .modal-dialog {
      max-width: 98%;
      width: auto !important;
      display: inline-block;
      margin: 1%;
    }
  }
}
</style>

